import script from "./BottomSheet.vue?vue&type=script&setup=true&lang=ts"
export * from "./BottomSheet.vue?vue&type=script&setup=true&lang=ts"

import "./BottomSheet.vue?vue&type=style&index=0&id=e23cf258&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e23cf258"]])

export default __exports__